import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import {
  getRankConfig,
  getFirstRank,
  getPersonRank,
  getGroupRank,
} from '@/api/rank'
import { useRoute } from 'vue-router'

// 一级排行
export const useFirstRank = () => {
  const store = useStore()
  const firstRankList = ref([])

  const fetchPersonFirstRank = async () => {
    const res = await getFirstRank({
      moduleId: store.getters.getQuesInfo?.moduleId,
    })

    if (res.ok) {
      firstRankList.value = res.data
      firstRankList.value.unshift({
        id: '',
        name: '全部',
        type: 52,
        status: 1,
        isChildren: 0,
      })
    }
  }

  return {
    firstRankList,
    fetchPersonFirstRank,
  }
}

// 个人排行
export const usePersonRank = () => {
  const route = useRoute()
  const store = useStore()
  const personPage = ref(1)
  const personRankList = ref([])
  const personLoading = ref(false)
  const personFinished = ref(false)
  // 个人排行当前二级
  const personSublevel = ref('')

  const fetchLoading = ref(false)

  const fetchPersonRank = async (personRankParams) => {
    if (fetchLoading.value) return

    const maxLen = store.getters.getRankConfig?.personFirst
    if (personRankParams?.refresh) {
      personPage.value = 1
      personRankList.value = []
      personFinished.value = false
    }

    const res = await getPersonRank({
      questionActiveKey: route.query.questionActiveKey,
      offset: personPage.value,
      pageSize: 10,
      firstId: personSublevel.value,
      secondId: personRankParams?.secondId,
      thirdId: personRankParams?.thirdId,
      orders: store.getters.getRankConfig?.rankBase,
    })

    if (res.ok) {
      if (res.data.rows.length === 0) {
        personFinished.value = true
        return
      }

      const list = res.data.rows

      list.forEach((item) => {
        item['text'] = formatEllipsis(
          (item.firstName || '') +
            (item.secondName || '') +
            (item.thirdName || ''),
          16
        )
      })
      personRankList.value = [...personRankList.value, ...list]

      // personRankList去重
      personRankList.value = personRankList.value.filter(
        (item, index, self) =>
          self.findIndex((t) => t.customerId === item.customerId) === index
      )

      personLoading.value = false
      personPage.value++
      if (personRankList.value.length >= maxLen) {
        personRankList.value = personRankList.value.slice(0, maxLen)
        personFinished.value = true
      }
    }
  }

  const formatEllipsis = (str = '', limitLen = 9) => {
    let len = 0,
      reg = /[\x00-\xff]/, //半角字符的正则匹配
      strs = str.split(''),
      inx = strs.findIndex((s) => {
        len += reg.test(s) ? 1 : 2
        if (len > limitLen) return true
      })
    return inx === -1 ? str : str.substr(0, inx) + '...'
  }

  return {
    personRankList,
    personLoading,
    fetchPersonRank,
    personFinished,
    personSublevel,
  }
}

// 单位排行
export const useGroupRank = () => {
  const route = useRoute()
  const store = useStore()
  const groupRankList = ref([])
  const groupFirstList = ref([])
  const personPage = ref(1)
  const groupLoading = ref(false)
  const groupFinished = ref(false)
  // 个人排行当前二级
  const groupSublevel = ref('')

  const fetchGroupRank = async (
    personRankParams = {
      firstId: '',
      secondId: '',
      thirdId: '',
    }
  ) => {
    if (personRankParams.refresh) {
      groupRankList.value = []
      groupFinished.value = false
      personPage.value = 1
    }
    const maxLen = store.getters.getRankConfig?.groupFirst

    const res = await getGroupRank({
      questionActiveKey: route.query.questionActiveKey,
      moduleId: store.getters.getQuesInfo?.moduleId,
      offset: personPage.value,
      pageSize: 10,
      firstId: personRankParams.firstId || groupSublevel.value,
      secondId: personRankParams.secondId,
      thirdId: personRankParams.thirdId,
      orders: store.getters.getRankConfig?.rankBase,
      rankRule: store.getters?.getRankConfig.rankRule,
    })

    if (res.ok) {
      if (res.data.rows.length === 0) {
        groupFinished.value = true
        return
      }

      //二级单位的数据
      if (personRankParams.firstId) {
        console.log('二级单位的数据')
        const list = res.data.rows

        list.forEach((e) => {
          e['display'] = true
        })
        groupRankList.value = [...groupRankList.value, ...list]
        personPage.value++
        groupLoading.value = false
      } else {
        console.log('一级单位的数据')
        const list = res.data.rows

        list.forEach((e) => {
          e['display'] = true
        })

        groupRankList.value = [...groupRankList.value, ...list]
        personPage.value++
        groupLoading.value = false
        if (groupRankList.value.length >= maxLen) {
          groupRankList.value = groupRankList.value.slice(0, maxLen)
          groupFinished.value = true
        }
      }
    }
  }

  return {
    groupRankList,
    fetchGroupRank,
    groupFirstList,
    groupLoading,
    groupFinished,
    groupSublevel,
  }
}

export const useGroupShowConfig = () => {
  const store = useStore()
  // 是否显示团体参与人数
  const showGroupPeronCount = computed(() => {
    return store.getters.getRankConfig?.display.indexOf('1') !== -1
  })
  // 是否显示团体参与次数
  const showGroupCount = computed(() => {
    return store.getters.getRankConfig?.display.indexOf('2') !== -1
  })
  // 是否显示团体分数
  const showGroupScore = computed(() => {
    return store.getters.getRankConfig?.display.indexOf('3') !== -1
  })

  return {
    showGroupPeronCount,
    showGroupCount,
    showGroupScore,
  }
}
